<template>
  <span>
    <van-button :class="is_mark?'is_mark':''" :loading="load" class="btn-is_mark_purple"
                @click="open"
    >{{ text }}
    </van-button>
    <van-popup v-model="show" :overlay-style="{background:'rgba(0,0,0,.3)'}"
               :style="{ height: '75%' , background: 'linear-gradient(118deg, #FFF0D3 0%, #E8B279 100%)'}"
               position="bottom" round>
      <div class="data-box">
          <div class="title-tips">
            请留下您的联系方式，将为您联系以下企业
          </div>
          <div class="company-box van-clearfix">
            <div>
              <van-image :src="company.logo" class="company-logo" fit="contain" lazy-load
              >
                  <template v-slot:error>无企业LOGO</template>
                </van-image>
            </div>
            <div>
               <div class="company-title">
                {{ company.CompanyName }}
              </div>
              <div class="company-CreditCode">
                统一信用代码：{{ company.CreditCode }}
              </div>
            </div>
          </div>
         <div class="title-tips">
            您的联系方式，可在下方修改
          </div>
        <van-form class="connect-form" @submit="onSubmit">
        <van-field
            v-model="form.company_name"
            :rules="[{ required: true, message: '您的企业工商全称' }]"
            label="企业全称"
            name="company_name"
            placeholder="请填写您的企业名称"
        />
        <van-field
            v-model="form.real_name"
            :rules="[{ required: true, message: '您的真实姓名' }]"
            label="真实姓名"
            name="real_name"
            placeholder="请填写您的真实姓名"
        />
          <van-field
              v-model="form.phone"
              :rules="[{ required: true, message: '您的手机号码，11位数字' }]"
              label="手机号码"
              name="phone"
              placeholder="请填写您的手机号"
          />
        <div style="margin: 16px;">
          <van-button :loading="load" block class="btn-submit" loading-text="保存中..." native-type="submit" round
                      type="info">立即提交</van-button>
        </div>
      </van-form>
        </div>
    </van-popup>
    </span>
</template>


<style scoped>
.btn-submit {
  background: #EB0035;
  border: 1px solid #EB0035;
  letter-spacing: 1px;
  margin-top: 60px;
}

.btn-is_mark_purple {
  background: #EB0035;
  text-align: center;
  display: inline-block;
  font-size: 12px;
  border-radius: 19px;
  color: #F8DEBF;
  border: none;
  min-width: 100px;
  height: 35px;
  cursor: pointer;
}

.btn-is_mark_purple.is_mark {
  opacity: .8;
  cursor: no-drop;
}

.btn-is_mark_purple:hover, .btn-is_mark_purple:active, .btn-is_mark_purple:focus {
  color: #FFFFFF;
  text-decoration: underline;
}

.data-box {
  padding: 15px;
  color: #907459;
}

.title-tips {
  font-size: 12px;
}

.company-box {
  margin-top: 10px;
  border: 1px solid rgba(252, 112, 74, 1);
  background: rgba(255, 255, 255, .4);
  margin-bottom: 20px;
  position: relative;
  padding: 20px 10px;
  border-radius: 2px;
  box-sizing: border-box;
  border-right: 5px solid rgba(252, 112, 74, 1);
}

.company-box::before {
  content: " ";
  background: url("~@/assets/images/bg_rank.png") no-repeat;
  background-size: contain;
  height: 120px;
  width: 75px;
  position: absolute;
  top: 0;
  right: 0;
}

.company-logo {
  object-fit: contain;
  width: 110px;
  height: 70px;
  margin-right: 10px;
  background: #FFFFFF;
  border-radius: 2px;
}

.company-box > div {
  float: left;
}

.company-box > div:nth-child(1) {
  width: 120px;
}

.company-box > div:nth-child(2) {
  width: calc(100% - 120px);
  font-size: 14px;
  font-weight: bold;
  height: 70px;
  display: grid;
  align-items: center;
}

.company-title {
  color: rgba(252, 112, 74, 1);
}

.connect-form {
  margin-top: 10px;
  border-radius: 2px;
}

body .company-logo /deep/ .van-image__error {
  text-align: center;
  font-size: 12px;
  border-radius: 3px;
}

.company-CreditCode {
  font-weight: normal;
  font-size: 12px;
  margin-top: 3px;
}
</style>
<script>
export default {
  name: "Connect",
  props: [
    'company'
  ],
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    };
    return {
      text: '联系Ta',
      load: false,
      show: false,
      is_mark: false,
      form: {
        company_name: "",
        real_name: "",
        phone: "",
        company_id: this.company.CompanyId,
      },
      rules: {
        phone: [
          {required: true, message: '请输入手机号，示例：185xxxx1234', trigger: 'change'},
          {validator: validatePhone, trigger: 'change'}
        ],
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.$store.state.isLogin) {
        this.load = true
        this.$axios.post(this.$apiconfg.connect_check, {
          company_id: this.company.CompanyId
        }).then(({data}) => {
          this.load = false
          if (data.code === 1) {
            if (data.is_mark) {
              this.text = '已联系'
            } else {
              this.text = '联系Ta'
            }
            this.is_mark = data.is_mark
          }
        }).catch(() => {
          this.load = false
        })
      }
    },
    open() {
      if (!this.$store.state.isLogin) {
        this.$notify({message: "请登录后再操作！", type: 'danger'})
        this.$router.push('/login')
        return
      }

      if (this.is_mark) {
        this.$notify({type: 'success', message: "您已提交申请，请耐心等待工作人员与您联系！"})
        return
      }

      this.show = true
      this.form.company_name = this.$store.state.auth.company.CompanyName
      this.form.real_name = this.$store.state.auth.RealName
      this.form.phone = this.$store.state.auth.call_phone

    },
    onSubmit() {
      this.load = true
      this.$axios.post(this.$apiconfg.connect_add, this.form).then(({data}) => {
        this.load = false
        if (data.code === 1) {
          this.show = false
          this.init()
        }
      })
    }
  }
}
</script>